import React from 'react';
import { X, Users } from 'lucide-react';

// 04-enforce.md 4.1 -- extraído de NewEvent.jsx: el campo de invitados (chips + input con
// autocompletado de miembros + dropdown de sugerencias). Presentacional; el estado
// (`guests`/`guestInput`/`suggestions`) vive en `useNewEventForm`.
const NeGuestsField = ({ guests, setGuests, guestInput, setGuestInput, suggestions, setSuggestions, allMembers, isInvited, t }) => {
  const addGuest = (g) => {
    setGuests([...guests, g]);
    setGuestInput('');
    setSuggestions([]);
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setGuestInput(val);
    if (!val.trim()) { setSuggestions([]); return; }
    const lower = val.toLowerCase();
    setSuggestions(
      allMembers
        .filter(m =>
          !guests.some(g => g.email === m.email) &&
          (m.name.toLowerCase().includes(lower) || m.email?.toLowerCase().includes(lower))
        )
        .slice(0, 4)
    );
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (suggestions.length > 0) {
        const u = suggestions[0];
        addGuest({ name: u.name, email: u.email, avatar: u.image, id: u.id });
      } else if (guestInput.trim()) {
        const val = guestInput.trim();
        addGuest({ name: val, email: val, avatar: null });
      }
    } else if (e.key === 'Backspace' && !guestInput && guests.length > 0) {
      if (isInvited) return;
      if (guests[guests.length - 1].isOwner) return;
      setGuests(guests.slice(0, -1));
    }
  };

  return (
    <div className="ne-row" style={{ alignItems: 'center' }}>
      <Users size={18} className="ne-icon" />
      <div className="ne-guests-wrapper" style={{ position: 'relative', flex: 1 }}>
        <div className="ne-guests-input-container">
          {guests.map((g, index) => (
            <div key={index} className="ne-guest-tag">
              <img
                src={g.avatar || `https://ui-avatars.com/api/?name=${g.name}`}
                alt={g.name}
                className="ne-guest-tag-avatar"
                style={g.isOwner ? { border: '1px solid #aaa' } : {}}
                loading="lazy"
              />
              <span className="ne-guest-tag-name">
                {g.name}
                {g.isOwner && <span style={{ opacity: 0.5, fontSize: '9px', marginLeft: 'var(--space-1)' }}>{t('eventModal.organizerTag')}</span>}
              </span>
              {!isInvited && !g.isOwner && (
                <X
                  size={12}
                  className="ne-guest-remove"
                  onClick={() => setGuests(guests.filter((_, i) => i !== index))}
                />
              )}
            </div>
          ))}
          <input
            className="ne-ghost-input"
            type="text"
            placeholder={guests.length === 0 ? t('eventModal.addGuestsPlaceholder') : ''}
            value={guestInput}
            disabled={isInvited}
            style={isInvited ? { cursor: 'not-allowed', color: '#666' } : {}}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </div>
        {suggestions.length > 0 && (
          <div className="ne-suggestions-dropdown">
            {suggestions.map(u => (
              <div
                key={u.id}
                className="ne-suggestion-item"
                onClick={() => addGuest({ name: u.name, email: u.email, avatar: u.image, id: u.id })}
              >
                <img
                  src={u.image || `https://ui-avatars.com/api/?name=${u.name}`}
                  alt={u.name}
                  className="ne-suggestion-avatar"
                  loading="lazy"
                />
                <div className="ne-suggestion-info">
                  <span className="ne-suggestion-name">{u.name}</span>
                  <span className="ne-suggestion-email">{u.email}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NeGuestsField;
